import { render, staticRenderFns } from "./PatentDetail.vue?vue&type=template&id=520db371"
import script from "./PatentDetail.vue?vue&type=script&lang=js"
export * from "./PatentDetail.vue?vue&type=script&lang=js"
import style0 from "./PatentDetail.vue?vue&type=style&index=0&id=520db371&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports